import { Clock, LogOut, Mail } from "lucide-react";
import { api, clearStudentId } from "@/lib/api";
import { toast } from "sonner";

export default function TrialExpired() {
  const handleContact = () =>
    toast.success("Thanks! Our team will reach out to you shortly to continue your SmartGuru journey.");
  const handleLogout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clearStudentId();
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center px-4" data-testid="trial-expired-page">
      <div className="max-w-md w-full bg-card rounded-3xl shadow-2xl p-8 text-center border border-border">
        <div className="w-14 h-14 rounded-2xl bg-secondary/15 flex items-center justify-center mx-auto mb-4">
          <Clock className="text-secondary" size={26} />
        </div>
        <h1 className="font-heading font-extrabold text-2xl mb-2">Your 7-day free trial has ended</h1>
        <p className="text-muted-foreground text-sm mb-6">
          We hope SmartGuru helped you learn something new! Contact us to keep your personal AI teacher going.
        </p>
        <button
          onClick={handleContact}
          data-testid="trial-expired-contact-button"
          className="w-full h-12 rounded-xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 mb-3 hover:bg-primary/90 active:scale-95 transition-all"
        >
          <Mail size={16} /> Contact Us to Continue
        </button>
        <button
          onClick={handleLogout}
          data-testid="trial-expired-logout-button"
          className="w-full h-11 rounded-xl border border-border text-muted-foreground font-semibold flex items-center justify-center gap-2 hover:bg-muted transition-colors"
        >
          <LogOut size={15} /> Log out
        </button>
      </div>
    </div>
  );
}
